<template>
  <div class="inlineFrame">
    <slot></slot>
  </div>
</template>

<script lang="ts">
export default {
  name: 'InlineFrameModal'
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.inlineFrame {
  overflow: hidden;
  height: auto;
  padding: 0;
  height: 100%;
}

::v-deep(iframe) {
  height: 100%;
}
</style>
